import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

async function request<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(
      response.status,
      text || response.statusText,
    );
  }

  const text = await response.text();
  if (!text) {
    return undefined as T;
  }

  return JSON.parse(text) as T;
}

export interface BudgetTemplate {
  id: number;
  name: string;
  description?: string | null;
  createdByUserId: string;
  createdByUserName: string;
  chapterCount: number;
  itemCount: number;
  created: string;
  canDelete: boolean;
}

export interface SaveBudgetAsTemplateRequest {
  name: string;
  description?: string | null;
}

export interface CreateBudgetFromTemplateRequest {
  templateId: number;
  budgetName: string;
}

export function getBudgetTemplates(): Promise<BudgetTemplate[]> {
  return request<BudgetTemplate[]>("/api/budget-templates");
}

export function saveBudgetAsTemplate(
  budgetId: number,
  payload: SaveBudgetAsTemplateRequest,
): Promise<number> {
  return request<number>(`/api/budget-templates/${budgetId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function createBudgetFromTemplate(
  payload: CreateBudgetFromTemplateRequest,
): Promise<number> {
  return request<number>("/api/budget-templates/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function deleteBudgetTemplate(templateId: number): Promise<void> {
  return request<void>(`/api/budget-templates/${templateId}`, {
    method: "DELETE",
  });
}
